<div
  [ngClass]="{'order-entry__screen-order__container': true, 'has-strategy': control.panels.strategyLayout.show || control.panels.gamma.show}"
  (click)="clickListener.subject.next($event)"
>
  <div class="order-entry__screen-order__container-inner" #orderEntryView>
    <!-- SPOT Entry Panel -->
    <oe-panel-spot-entry
      #panelSpot
      *ngIf="control.panels.spot.show"
      [refId]="refId"
      [rootRefId]="rootRefId"
      [entryType]="entryType"
      [operationMode]="operationMode"
      [(tab)]="control.activeTabIndex"
      (tabIndexChange)="handlePanelTabChange($event)"
      (dataLoadCompleted)="handlePanelLoadCompleted($event)"
    >
    </oe-panel-spot-entry>
    <!-- ALGO Entry Panel -->
    <oe-panel-algo-entry
      #panelAlgo
      *ngIf="control.panels.algo.show"
      [refId]="refId"
      [rootRefId]="rootRefId"
      [entryType]="entryType"
      [operationMode]="operationMode"
      [(tab)]="control.activeTabIndex"
      (tabIndexChange)="handlePanelTabChange($event)"
      (dataLoadCompleted)="handlePanelLoadCompleted($event)"
    >
    </oe-panel-algo-entry>
    <oe-panel-ndf-algo-entry
      #panelNdfAlgo
      *ngIf="control.panels.ndfAlgo.show"
      [refId]="refId"
      [rootRefId]="rootRefId"
      [entryType]="entryType"
      [operationMode]="operationMode"
      [(tab)]="control.activeTabIndex"
      (tabIndexChange)="handlePanelTabChange($event)"
      (dataLoadCompleted)="handlePanelLoadCompleted($event)"
    >
    </oe-panel-ndf-algo-entry>
    <!-- NDF Entry Panel -->
    <oe-panel-ndf-entry
      #panelNdf
      *ngIf="control.panels.ndf.show"
      [refId]="refId"
      [rootRefId]="rootRefId"
      [entryType]="entryType"
      [operationMode]="operationMode"
      [(tab)]="control.activeTabIndex"
      (tabIndexChange)="handlePanelTabChange($event)"
      (dataLoadCompleted)="handlePanelLoadCompleted($event)"
    >
    </oe-panel-ndf-entry>
    <!-- BMARK Entry Panel -->
    <oe-panel-bmark-entry
      #panelBmark
      *ngIf="control.panels.bmark.show"
      [refId]="refId"
      [rootRefId]="rootRefId"
      [entryType]="entryType"
      [operationMode]="operationMode"
      [(tab)]="control.activeTabIndex"
      (tabIndexChange)="handlePanelTabChange($event)"
      (dataLoadCompleted)="handlePanelLoadCompleted($event)"
    >
    </oe-panel-bmark-entry>
    <!-- GAMMA Entry Panel -->
    <oe-panel-gamma-entry
      #panelGamma
      *ngIf="control.panels.gamma.show"
      [refId]="refId"
      [rootRefId]="rootRefId"
      [entryType]="entryType"
      [operationMode]="operationMode"
      [(tab)]="control.activeTabIndex"
      (tabIndexChange)="handlePanelTabChange($event)"
      (dataLoadCompleted)="handlePanelLoadCompleted($event)"
    >
    </oe-panel-gamma-entry>

    <div class="flex-spacer"></div>

    <!-- Order Execution monitoring -->
    <bfx-execution-monitor
      class="oesc-execution-monitor"
      *ngIf="executionOrderId"
      [orderId]="executionOrderId"
      [monitoringEnabled]="executionMonitoringEnabled"
      [useLocalCallout]="false"
      (onCalloutChange)="executionCalloutChange($event)"
    >
    </bfx-execution-monitor>

    <!-- NOTIFICATIONS Panel -->
    <bfx-panel-notifications
      [style.display]="!control.panels.notifications.show ? 'none':'block'"
      [refId]="refId"
      [rootRefId]="rootRefId"
      [entryType]="entryType"
      [operationMode]="operationMode"
    >
    </bfx-panel-notifications>
    <!-- ACTIONS Panel -->
    <bfx-panel-actions
      #panelActions
      *ngIf="control.panels.actions.show"
      [refId]="refId"
      [rootRefId]="rootRefId"
      [entryType]="entryType"
      [operationMode]="operationMode"
      [scratchpad]="scratchpad"
      [loadingComplete]="control.panelLoadCompleted"
    >
    </bfx-panel-actions>
    <!--DEBUG Panel -->
    <oe-panel-debug
      #panelDebug
      class="order-entry__screen-order__debug"
      *ngIf="control.panels.debug.show"
      [refId]="refId"
      [rootRefId]="rootRefId"
      [refIds]="refIds"
      [entryType]="entryType"
    >
    </oe-panel-debug>
  </div>
  <div
    [style.display]="control.panels.strategyLayout.show ? 'flex': 'none'"
    #strategyView
    class="order-entry__screen-order_strategy_layout"
  >
    <!-- STRATEGY Panel -->
    <bfx-panel-strategy #panelStrategy [refId]="refId" [rootRefId]="rootRefId">
    </bfx-panel-strategy>
    <!-- [height]="control.panels.strategyLayout.height" -->
  </div>
  <div *ngIf="control.panels.gamma.show" #gammaContainer class="order-entry__screen-order__gamma">
    <!-- STRATEGY Panel -->
    <oe-panel-gamma-viewer #gammaLegViewer [refId]="rootRefId"> </oe-panel-gamma-viewer>
    <bfx-panel-customise #panelCustomise [refId]="refId" [rootRefId]="rootRefId">
    </bfx-panel-customise>
    <!-- [height]="control.panels.strategyLayout.height" -->
  </div>
</div>
